import { r as l, h as t } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const i = ".sc-reply-all-icon-h{display:flex}", s = i, h = class {
  constructor(e) {
    l(this, e), this.width = "15", this.height = "15";
  }
  render() {
    return t("svg", { key: "97a6ca7a284eb23b96f84b08e7d503edc32f8c2b", fill: "auto", width: this.width, height: this.height, viewBox: "0 0 1920 1920", xmlns: "http://www.w3.org/2000/svg" }, t("path", { key: "1eb3304f845f0f9f7dfa3c440e45b807a14a9a23", d: "m1030.975 188 81.249 81.249-429.228 429.228h300.747c516.223 0 936.257 420.034 936.257 936.257v98.028h-114.92v-98.028c0-452.901-368.436-821.337-821.337-821.337H682.996l429.228 429.229-81.25 81.248-567.936-567.937L1030.975 188Zm-463.038.011 81.249 81.25-486.688 486.688 486.688 486.688-81.249 81.249L0 755.949 567.937 188.01Z", "fill-rule": "evenodd" }));
  }
};
h.style = s;
export {
  h as reply_all_icon
};
